import { useEffect, useState } from 'react';
import { useNavigate } from '@tanstack/react-router';

import { useIsMobile } from '@repo/lib/hooks/useMediaQuery';
import { rawString } from '../../Language/Language';
import { filterItemsByEligibility } from '../../../utils/item';
import { useWorkflow } from '../../../workflow/hooks';
import { showMoreCutoff } from './ShowMoreButton';
import { useToast } from '@repo/ui/Toast/ToastRoot';
import { IneligibleItemsView } from './IneligibleItemsView';

export const IneligibleItems = () => {
  const isMobile = useIsMobile();
  const { order, retailer } = useWorkflow();
  const { customer, items = [], orderNumber } = order ?? {};
  const navigate = useNavigate();
  const { errorToast } = useToast();

  const ineligibleItems = filterItemsByEligibility(items, false) ?? [];

  const notCutoff = ineligibleItems.length <= showMoreCutoff;

  const [showMore, setShowMore] = useState(false);

  useEffect(() => {
    setShowMore(notCutoff);
  }, [notCutoff, setShowMore]);

  const handleClick = (itemId: string) => {
    if (!itemId) {
      return errorToast({
        message:
          rawString({
            langKey: 'Global.itemSelection.ineligible.navigationError',
          }) ?? '',
      });
    }

    navigate({
      to: '/$retailer/ineligible-details/$itemId',
      params: { itemId, retailer: retailer ?? 's' },
      search: true,
    });
  };

  return (
    <IneligibleItemsView
      ineligibleItems={ineligibleItems}
      isMobile={isMobile}
      showMore={showMore}
      onShowMore={() => setShowMore(true)}
      onItemClick={handleClick}
      orderNumber={orderNumber}
      customerFirstName={customer?.firstName}
      customerLastName={customer?.lastName}
    />
  );
};
